import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';

import { api_crud_route, data_interface, endpoints } from './Config';

import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import {

	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

} from '../../../Utils';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);

	const [lang, set_lang] = useState('pt');

	const [isloading, setLoading] = useState(true);
	const [isRedirect, setRedirect] = useState(false);

	const [show_delete_button, set_show_delete_button] = useState(false);

	//const [disabled, set_disabled] = useState(true)

	const [is_edit, set_is_edit] = useState(false)

	const fetch_id_info = async (id_serch) => {

		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);

			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();

        set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	const handleSubmit = async e => {
		e.preventDefault();

		if (is_edit === true) {

			Swal.fire({
				title: language[lang].edit_title,
				text: language[lang].edit_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].edit_confirm,
				cancelButtonText: language[lang].edit_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPUT(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].edit_error, '', 'info'))
				}
			})

		} else {

			Swal.fire({
				title: language[lang].insert_title,
				text: language[lang].insert_text,
				icon: 'question',
				showCancelButton: true,
				confirmButtonColor: '#0095e8',
				cancelButtonColor: '#d9214e',
				confirmButtonText: language[lang].insert_confirm,
				cancelButtonText: language[lang].insert_cancel
			})
			.then((result) => {
				if (result.isConfirmed) {
					reqPOST(api_crud_route, dados.current)
						.then(() => { props.history.push(endpoints.list) })
						.catch(() => Swal.fire(language[lang].insert_error, '', 'info'))
				}
			})

		}
	}

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: dados.current.id })
					.then(() => {
						props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})
		.catch((erro) => {
			console.log(erro)
		})
		
	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)

		if(name === 'bgColor')
			set_dados(dados.current.info.borderColor = value)

	}

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].category}</h2>
					<p>{language[lang].category} / { dados.current.id !== '' ? language[lang].category_edit : language[lang].category_new }</p>
				</div>
		
				<div className={`dash-cards body`}>
                	<div className="container">
						<div className="card mb-5 mb-xl-10">
							<div>
								<form id="form" onSubmit={handleSubmit}>
									<div className="card-body">
										<div className="row mb-6">
											<div className="col-md-6">
												<label className="fs-5 fw-bold mb-2">{language[lang].name}</label>
												<input type="text" name="name" value={dados.current.info.name} className="form-control" placeholder={language[lang].name_placeholder} onChange={handle_change_info} required />
											</div>

											<div className="col-md-6">
												<label className="fs-5 fw-bold mb-2">{language[lang].color}</label>
												<div className="input-group">
													<div className="me-5">
														<input type="color" name="bgColor" value={dados.current.info.bgColor} className="form-control form-control-color me-4" placeholder={language[lang].color_placeholder} onChange={handle_change_info} required />
													</div>
													<span className="form-control">{dados.current.info.bgColor}</span>
												</div>
											</div>
										</div>

										<div className="card-footer d-none">
											<Link className="btn btn-light btn-active-light-primary me-2" to={{ pathname: endpoints.list }}  >
												<span>{language[lang].cancel}</span>
											</Link>

											<button type="button" onClick={() => apagar(dados.current.id)} className={show_delete_button ? "btn btn-danger me-2" : "d-none"}>
												<span>{language[lang].delete}</span>
											</button>

											<button type="submit" form="form" className="btn btn-primary">
												<span>{language[lang].save}</span>
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<img alt='' src={'./img/cancelar.svg'} />
										<span>{language[lang].cancel}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<img alt='' src={'./img/eliminar_b.svg'} />
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<img alt='' src={'./img/save.svg'} />
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
